import { render, staticRenderFns } from "./Uploader.vue?vue&type=template&id=68ce3af7"
import script from "./Uploader.vue?vue&type=script&lang=js"
export * from "./Uploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports